module.exports = __webpack_public_path__ + "img/roc.93b41e94.png";